import React from 'react';

export default function Time({ time, color = 'black' }) {
  return (
    <>
      <span style={{ color }}>
        {`0${Math.floor(time / (60 * 60))}`.slice(-2)}
        :
      </span>
      <span style={{ color }}>
        {`0${Math.floor((time / 60) % 60)}`.slice(-2)}
        :
      </span>
      <span style={{ color }}>{`0${time % 60}`.slice(-2)}</span>
    </>
  );
}
